import { IAppState } from '../common/state';

export const getJsonQuery = ({ results: { jsonQuery } }: IAppState) => {
  return jsonQuery;
};
